import { EasyModal, EasyImg, FormPage } from 'src/components'
import { getSingleRule } from 'src/utils/common'
import 'enasops/styles/op/087/index.less'

export default {
  renderGateway (text: any, record: any, ListTableContext: any) {
    const formData = { filterGroup: { Rules: [getSingleRule('Nav_Tenant_Bind.TENANT_ID', 1, record.ID)] } }
    return (
      <div className='display-flex flex-rowfsc'>
        <span className='op087__listtext'>{text}</span>
        <EasyModal
          modal={{ title: 'ECM设备信息', width: '80%' }}
          slot={<EasyImg src={require('enasops/assets/op/101/search.png')} className='op087__listimg' />}
          slotStyle={{ fontSize: 0 }}
        >
          <FormPage formCode='OP096' formData={formData} />
        </EasyModal>
      </div>
    )
  },
  renderUser (text: any, record: any, ListTableContext: any) {
    const formData = { filterGroup: { Rules: [getSingleRule('TENANT_ID', 1, record.ID)] } }
    return (
      <div className='display-flex flex-rowfsc'>
        <span className='op087__listtext'>{text}</span>
        <EasyModal
          modal={{ title: '用户信息', width: '80%' }}
          slot={<EasyImg src={require('enasops/assets/op/101/search.png')} className='op087__listimg' />}
          slotStyle={{ fontSize: 0 }}
        >
          <FormPage formCode='OP095' formData={formData} />
        </EasyModal>
      </div>
    )
  },
  renderApp (text: any, record: any, ListTableContext: any) {
    const formData = { filterGroup: { Rules: [getSingleRule('TENANT_ID', 1, record.ID)] } }
    return (
      <div className='display-flex flex-rowfsc'>
        <span className='op087__listtext'>{text}</span>
        <EasyModal
          modal={{ title: '用户信息', width: '80%' }}
          slot={<EasyImg src={require('enasops/assets/op/101/search.png')} className='op087__listimg' />}
          slotStyle={{ fontSize: 0 }}
        >
          <FormPage formCode='OP089' formData={formData} />
        </EasyModal>
      </div>
    )
  },
}